export default "__VITE_ASSET__fcaac76a__"